import createIcon from '../../createIcon';

/**
 * @component @name TurnRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuMTcgMTBMMTMuNTggMTEuNTlMMTUgMTNMMTkgOUwxNSA1TDEzLjU5IDYuNDFMMTUuMTcgOEg3QzUuOSA4IDUgOC45IDUgMTBWMTlIN1YxMEgxNS4xN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TurnRight = createIcon('TurnRight', [
  [
    'path',
    {
      d: 'M15.17 10L13.58 11.59L15 13L19 9L15 5L13.59 6.41L15.17 8H7C5.9 8 5 8.9 5 10V19H7V10H15.17Z',
      key: '1aiay6',
    },
  ],
]);

export default TurnRight;
